import ShowAll from "./ShowAll";

const Logs = { ShowAll};

export default Logs;

export {
    ShowAll
}